/**
 * 바이너리 문자열(문자당 1바이트) → Uint8Array.
 *
 * `Uint8Array.from(str, (c) => c.charCodeAt(0))` 은 문자열을 이터레이터로 순회해
 * 1글자 문자열 수천만 개를 임시 리스트로 만든다(V8 IterableToList) → 첨부 50MB 부터
 * OOM 크래시(2026-08-07 실측, scratchpad/upload-bench). 사전 할당 + 인덱스 루프로 대체.
 *
 * 코드 포인트가 255를 넘으면 Uint8Array 대입이 하위 바이트로 자른다 — 기존 동작과 동일.
 */
export default function binaryStringToUint8Array(binaryStr) {
  const len = binaryStr.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryStr.charCodeAt(i)
  }
  return bytes
}
